var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconMessageUnreadComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'mag-seller';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-MessageUnread").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 17", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.60476 13.1047C5.58323 13.0906 5.56259 13.0742 5.54316 13.0552L1.72988 9.3434C1.57007 9.18784 1.56834 8.93163 1.72604 8.77393L2.21718 8.28279C2.37339 8.12658 2.62666 8.12658 2.78287 8.28279L5.95105 11.451L13.3631 3.2755C13.5093 3.11425 13.7576 3.09949 13.9219 3.24229L14.448 3.6996C14.6179 3.84737 14.6325 4.1063 14.4801 4.27214L6.28237 13.1927C6.12841 13.3603 5.8659 13.3658 5.70501 13.2049L5.60476 13.1047Z" }));
}
var IconMessageUnread = React.forwardRef(IconMessageUnreadComponent);
export default IconMessageUnread;
